import React, { Fragment, FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { KeyValue } from "../../../ui/KeyValue/KeyValue";
import { PriceDisplay } from "../../../ui/PriceDisplay/PriceDisplay";
import { getPriceTranslationKey } from "../../PriceSelect/getPriceTranslationKey";
import { usePricing } from "../../PriceSelect/usePricing";
import { usePricingLabelOverride } from "../../PriceSelect/usePricingLabelOverride";
import { gridCellClass } from "./TireComparisonGrid";
import { useShouldRenderPricing } from "./useShouldRenderPricing";

type ProductInfoProps = {
  isStaggered: boolean;
  part: TirePartItem;
};

export const PricingDetails: FunctionComponent<ProductInfoProps> = ({
  isStaggered,
  part,
}) => {
  const { t } = useTranslation();
  const defaultQuantity = isStaggered ? "2" : "4";
  const { entries, total } = usePricing({
    defaultQuantity,
    isStaggered,
    part,
  });
  const pricingLabelOverride = usePricingLabelOverride(part);

  return (
    <div className={gridCellClass}>
      {useShouldRenderPricing(part) ? (
        <>
          {entries.map(([combinedPart, selectedPriceOption], index) => {
            return (
              <Fragment key={combinedPart.itemId}>
                <KeyValue className="justify-between">
                  <>
                    {t(
                      getPriceTranslationKey(
                        isStaggered,
                        index,
                        pricingLabelOverride
                      )
                    )}
                    :
                  </>
                  <PriceDisplay>
                    {selectedPriceOption.context.displayPrice}
                  </PriceDisplay>
                </KeyValue>
                <KeyValue className="justify-between">
                  <>{t("compare.quantity")}:</>
                  <>{selectedPriceOption.quantity}</>
                </KeyValue>
              </Fragment>
            );
          })}
          <KeyValue className="justify-between">
            <>{t("compare.total")}:</>
            <PriceDisplay>{total}</PriceDisplay>
          </KeyValue>
        </>
      ) : (
        t("compare.notAvailable")
      )}
    </div>
  );
};
